import type { ElementType } from "react";

/** Single-line listing title — fixed height + ellipsis keeps card grids aligned. */
export const listingTitleClassName =
  "block min-w-0 line-clamp-1 min-h-4 truncate text-xs font-medium leading-4 text-white/90";

export function listingTitleClass(className = ""): string {
  return className ? `${listingTitleClassName} ${className}` : listingTitleClassName;
}

export function ListingTitle({
  children,
  className = "",
  as: Tag = "p",
}: {
  children: string;
  className?: string;
  as?: ElementType;
}) {
  return (
    <Tag className={listingTitleClass(className)} title={children}>
      {children}
    </Tag>
  );
}
